<template>
	<div class="flex flex-col">
		<div class="flex flex-col bg-primary px-6 py-10">
			<div
				class="flex w-full max-w-screen-lg items-center self-center max-lg:flex-col max-lg:space-y-9 lg:space-s-20"
			>
				<div class="flex flex-grow flex-col max-lg:text-center">
					<span class="text-white text-2xl font-black md:text-3xl">
						{{ $t("top_section_title", { hr: $t("human_resource") }) }}
					</span>
					<span class="text-white mt-4 text-base md:text-lg">
						{{ $t("what_make_us_better_description") }}
					</span>
				</div>
				<NuxtLink
					v-if="!user?.id"
					:to="$routeUrl.LoginUrl()"
					class="ripple-bg-white flex-shrink-0 rounded-md px-8 py-3 text-sm font-bold text-primary"
				>
					{{ $t("login_register") }}
				</NuxtLink>
				<NuxtLink
					v-else
					:to="$routeUrl.PanelDashboardUrl()"
					class="ripple-bg-white flex-shrink-0 rounded-md px-8 py-3 text-sm font-bold text-primary"
				>
					{{ $t("dashboard") }}
				</NuxtLink>
			</div>
		</div>
		<div class="bg-white flex flex-col px-6 py-16">
			<div class="grid w-full max-w-screen-xl grid-cols-1 gap-x-10 gap-y-16 self-center lg:grid-cols-3">
				<div
					class="flex flex-col max-lg:border-slate-200 max-lg:items-center max-lg:border-b max-lg:pb-16 max-lg:text-center"
				>
					<NuxtLink :to="$routeUrl.HomeUrl()">
						<img src="/img/app_logo.png" alt="" class="h-12 w-auto" />
					</NuxtLink>
					<p class="mt-5 max-w-xs text-center text-xs text-[#382C5C] lg:max-w-[250px] lg:text-start">
						{{ $t("app_description") }}
					</p>
				</div>
				<div class="flex flex-col">
					<span class="text-lg font-bold text-[#382C5C]">
						{{ $t("pages") }}
					</span>
					<div class="mt-1 flex flex-wrap items-start">
						<NuxtLink
							v-for="(item, i) in menuItems"
							:key="i"
							:to="item.link"
							:class="['me-6 mt-3 text-sm font-normal text-[#382C5C] duration-300 hover:text-primary']"
						>
							{{ item.title }}
						</NuxtLink>
					</div>
				</div>
				<div class="flex flex-col">
					<span class="text-lg font-bold text-[#382C5C]">
						{{ $t("contact_us") }}
					</span>
					<span class="mt-4 text-sm text-[#382C5C]">
						{{ $t("we_are_just_one_call_away") }}
					</span>
					<NuxtLink
						:to="$routeUrl.ContactUsUrl()"
						class="ripple-bg-primary text-white mt-3 flex-shrink-0 self-start rounded-md px-8 py-3 text-sm font-bold"
					>
						{{ $t("contact_us") }}
					</NuxtLink>
					<div class="mt-4 flex items-center text-xs font-medium text-[#382C5C]">
						<Icon name="mdi:email-outline" class="me-2.5 h-5 w-5 flex-shrink-0" />
						<span>
							{{
								generalStore.socialLinks?.find((v) => v.id == "email")?.value ||
								"dev.codegames@gmail.com"
							}}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
const app = useNuxtApp()
const userStore = useUserStore()
const generalStore = useGeneralStore()

const user = computed(() => userStore.user)

const menuItems = computed(() => [
	{
		title: app.$i18n.t("blog"),
		link: app.$routeUrl.BlogUrl()
	},
	{
		title: app.$i18n.t("about_us"),
		link: app.$routeUrl.AboutUsUrl()
	},
	{
		title: app.$i18n.t("contact_us"),
		link: app.$routeUrl.ContactUsUrl()
	},
	{
		title: app.$i18n.t("rules"),
		link: app.$routeUrl.RulesUrl()
	},
	{
		title: app.$i18n.t("login_register"),
		link: app.$routeUrl.LoginUrl()
	}
])
</script>
